"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caregiver = exports.CaregiverType = void 0;
const carabiners_1 = require("@clearsummit/carabiners");
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
const group_1 = require("./group");
const photo_1 = __importDefault(require("./photo"));
var CaregiverType;
(function (CaregiverType) {
    CaregiverType["CASE_MANAGEMENT"] = "CASE_MANAGEMENT";
    CaregiverType["THERAPY"] = "THERAPY";
})(CaregiverType = exports.CaregiverType || (exports.CaregiverType = {}));
class Caregiver {
    constructor(data = {
        id: null,
        caregiver: null,
        caregiver_microsoft_url: null,
        meeting_url: null,
        relationship_type: null,
    }) {
        this.id = defaults_1.defaultString(data.id);
        this.caregiver = defaults_1.defaultCamelCaseObject(data.caregiver);
        this.caregiverMicrosoftUrl = defaults_1.defaultString(data.caregiver_microsoft_url);
        this.meetingUrl = defaults_1.defaultString(data.meeting_url);
        this.relationshipType = defaults_1.defaultEnum(data.relationship_type, CaregiverType);
    }
    get email() {
        return defaults_1.defaultString(this.caregiver.email);
    }
    get firstName() {
        return defaults_1.defaultString(this.caregiver.firstName);
    }
    get lastName() {
        return defaults_1.defaultString(this.caregiver.lastName);
    }
    get phone() {
        return defaults_1.defaultString(this.caregiver.phone);
    }
    get formattedPhone() {
        const { parsePhoneNumber } = carabiners_1.PhoneHelper();
        if (this.phone && parsePhoneNumber) {
            const parsedPhoneNumber = parsePhoneNumber(this.phone);
            if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
                return parsedPhoneNumber.formatNational() || this.phone;
            }
        }
        return this.phone === '' ? '--' : this.phone;
    }
    get microsoftUrl() {
        return defaults_1.defaultString(this.caregiverMicrosoftUrl);
    }
    get name() {
        return defaults_1.defaultString(carabiners_1.joinStr(this.firstName, this.lastName));
    }
    get meetingLink() {
        return defaults_1.defaultString(this.meetingUrl);
    }
}
exports.Caregiver = Caregiver;
class User extends base_model_1.default {
    constructor(data = {
        id: null,
        email: null,
        username: null,
        first_name: null,
        last_name: null,
        token: null,
        programs: null,
        accepted_tos: null,
        photo: null,
        phone: null,
        therapist: null,
        case_manager: null,
        group: null,
        is_active: null,
        show_paywall: null,
        session_price: null,
        total_missing_sessions: null,
        patient_responsibility: null,
        paywall_active: null,
        group_id: null,
        total_paid_sessions: null,
        program_id: null,
        meeting_url: null,
        calendar_url: null,
        caregiver_type: null,
        stripe_link: null,
        total_sessions: null
    }) {
        super(data);
        this.email = defaults_1.defaultString(data.email);
        this.username = defaults_1.defaultString(data.username);
        this.first_name = defaults_1.defaultString(data.first_name);
        this.last_name = defaults_1.defaultString(data.last_name);
        this.token = defaults_1.defaultObject(data.token);
        this.programs = defaults_1.defaultArray(data.programs);
        this.accepted_tos = defaults_1.defaultBoolean(data.accepted_tos);
        this.phone = defaults_1.defaultString(data.phone);
        this.photo = new photo_1.default(defaults_1.defaultObject(data.photo));
        this.therapist = new Caregiver(defaults_1.defaultObject(data.therapist));
        this.case_manager = new Caregiver(defaults_1.defaultObject(data.case_manager));
        this.group = defaults_1.defaultEnum(data.group, group_1.GroupType);
        this.is_active = defaults_1.defaultBoolean(data.is_active);
        this.show_paywall = defaults_1.defaultBoolean(data.show_paywall);
        this.session_price = defaults_1.defaultFloat(data.session_price);
        this.total_missing_sessions = defaults_1.defaultNumber(data.total_missing_sessions);
        this.patient_responsibility = defaults_1.defaultFloat(data.patient_responsibility);
        this.paywall_active = defaults_1.defaultBoolean(data.paywall_active);
        this.group_id = defaults_1.defaultNumber(data.group_id);
        this.total_paid_sessions = defaults_1.defaultNumber(data.total_paid_sessions);
        this.program_id = defaults_1.defaultNumber(data.program_id);
        this.meeting_url = defaults_1.defaultString(data.meeting_url);
        this.calendar_url = defaults_1.defaultString(data.calendar_url);
        this.caregiver_type = defaults_1.defaultEnum(data.caregiver_type, CaregiverType);
        this.stripe_link = defaults_1.defaultString(data.stripe_link);
        this.total_sessions = defaults_1.defaultNumber(data.total_sessions);
    }
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    get caseManager() {
        return this.case_manager;
    }
    get totalSessionPrice() {
        return +(this.totalMissingSessions * this.sessionPrice).toFixed(2);
    }
}
exports.default = User;
defaults_1.assignGetSet(User, { snake: 'first_name', camel: 'firstName' });
defaults_1.assignGetSet(User, { snake: 'last_name', camel: 'lastName' });
defaults_1.assignGetSet(User, { snake: 'accepted_tos', camel: 'acceptedToS' });
defaults_1.assignGetSet(User, { snake: 'caregiver_microsoft_url', camel: 'caregiverMicrosoftUrl' });
defaults_1.assignGetSet(User, { snake: 'is_active', camel: 'isActive' });
defaults_1.assignGetSet(User, { snake: 'show_paywall', camel: 'showPaywall' });
defaults_1.assignGetSet(User, { snake: 'session_price', camel: 'sessionPrice' });
defaults_1.assignGetSet(User, { snake: 'total_missing_sessions', camel: 'totalMissingSessions' });
defaults_1.assignGetSet(User, { snake: 'patient_responsibility', camel: 'patientResponsibility' });
defaults_1.assignGetSet(User, { snake: 'paywall_active', camel: 'paywallActive' });
defaults_1.assignGetSet(User, { snake: 'group_id', camel: 'groupId' });
defaults_1.assignGetSet(User, { snake: 'total_paid_sessions', camel: 'totalPaidSessions' });
defaults_1.assignGetSet(User, { snake: 'program_id', camel: 'programId' });
defaults_1.assignGetSet(User, { snake: 'meeting_url', camel: 'meetingUrl' });
defaults_1.assignGetSet(User, { snake: 'calendar_url', camel: 'calendarUrl' });
defaults_1.assignGetSet(User, { snake: 'caregiver_type', camel: 'caregiverType' });
defaults_1.assignGetSet(User, { snake: 'stripe_link', camel: 'stripeLink' });
defaults_1.assignGetSet(User, { snake: 'total_sessions', camel: 'totalSessions' });
